
// 比赛复盘数据适配模块

import lodash from "lodash"
import LegsStatReader from "@/utils/legs_stat_reader"
import LegsTimelineReader from "@/utils/legs_timeline_reader"

var GameReplayDataLoader = {

  generate_hero_positions: function(stat, timeline){

    var gamePlayers = LegsStatReader.get_game_players(stat)

    var frameInterval = LegsTimelineReader.get_frame_interval(timeline)
    var gameFrames = LegsTimelineReader.get_all_frames(timeline)

    var newHeroPositions = {}

    lodash.each(gamePlayers, function(player){

      var championId = player.championId
      var participantId = player.participantId

      var hotPoints = []

      //读取timeline中的每一帧，组成选手走位路线
      lodash.each(gameFrames, function(gameFrame){

        var playerFrame = gameFrame[participantId]

        if(!playerFrame){
          return
        }

        var framePoint = null
        if(playerFrame.position){
          framePoint = {
            axis_x: playerFrame.position.x,
            axis_y: playerFrame.position.y
          }
        }

        hotPoints.push(framePoint)
      })

      newHeroPositions[championId] = {
        hero_id: championId,
        group_id: player.teamId,
        hot_point: hotPoints,
        count: hotPoints.length,
        interval: frameInterval,
        resolution: 0,
        update_time: 0
      }
    })

    return newHeroPositions
  },
  generate_hero_kill_events: function(stat, timeline){

    var gamePlayers = LegsStatReader.get_game_players(stat)

    var hitPlayers = {}
    lodash.each(gamePlayers, function(player){
      hitPlayers[player.participantId] = player
    })

    var gameEvents = LegsTimelineReader.get_all_events(timeline)

    var killEvents = []

    lodash.each(gameEvents, function(event){

      if(event.type != "CHAMPION_KILL"){
        return
      }

      var assistors = []
      lodash.each(event.assistingParticipantIds, function(partId){
        var player = hitPlayers[partId]
        if(!player){
          return
        }
        assistors.push(player.originalAccountId)
      })

      var killer = hitPlayers[event.killerId]

      var victim = hitPlayers[event.victimId]
      if(!victim){
        return
      }

      var killEvent = {
        assistor: assistors,
        event_time: event.timestamp,
        killer_id: killer ? killer.participantId : 0,
        point_x: event.position.x,
        point_y: event.position.y,
        victim_color: victim.teamId == 200 ? 2 : 1,
        victim_id: victim.participantId,
        victim_team_id: victim.teamId
      }

      killEvents.push(killEvent)
    })

    return killEvents
  },
  generate_hero_economy: function(stat, timeline){

    var gamePlayers = LegsStatReader.get_game_players(stat)

    var frameInterval = LegsTimelineReader.get_frame_interval(timeline)
    var gameFrames = LegsTimelineReader.get_all_frames(timeline)

    var newHeroEconomy = {}

    lodash.each(gamePlayers, function(player){

      var championId = player.championId
      var participantId = player.participantId

      var moneyList = []

      //读取timeline中的每一帧，组成选手的经济曲线
      lodash.each(gameFrames, function(gameFrame){

        var playerFrame = gameFrame[participantId]

        if(!playerFrame){
          return
        }

        moneyList.push(playerFrame.totalGold)
      })

      newHeroEconomy[championId] = {
        hero_id: championId,
        group_id: player.teamId,
        money_count: moneyList.length,
        money_list: moneyList,
        team_id: player.teamId,
        uin: player.originalAccountId,
        interval: frameInterval,
        user_id: 0
      }
    })

    return newHeroEconomy
  },
  generate_buildings_data: function(stat, timeline){

    var gamePlayers = LegsStatReader.get_game_players(stat)

    var hitPlayers = {}
    lodash.each(gamePlayers, function(player){
      hitPlayers[player.participantId] = player
    })

    var gameEvents = LegsTimelineReader.get_all_events(timeline)

    var buildingsData = []

    lodash.each(gameEvents, function(event){

      if(event.type != "BUILDING_KILL"){
        return
      }

      var killer = hitPlayers[event.killerId]
      var killerId
      var killerTeamId
      if(killer){
        killerId = killer.participantId
        killerTeamId = killer.teamId
      }else{
        killerId = 0
        killerTeamId = event.teamId == 100 ? 200 : 100
      }

      var buildingData = {
        born_color: event.teamId == 100 ? 1 : 2,
        born_team_id: event.teamId,
        building_type: event.buildingType,
        event_time: event.timestamp,
        killer_color: killerTeamId == 100 ? 1 : 2,
        killer_id: killerId,
        killer_team_id: killerTeamId,
        lane_type: event.laneType,
        point_x: event.position.x,
        point_y: event.position.y,
        tower_type: event.towerType
      }

      buildingsData.push(buildingData)
    })

    return buildingsData
  },
  generate_monsters_data: function(stat, timeline){

    var gamePlayers = LegsStatReader.get_game_players(stat)

    var hitPlayers = {}
    lodash.each(gamePlayers, function(player){
      hitPlayers[player.participantId] = player
    })

    var gameEvents = LegsTimelineReader.get_all_events(timeline)

    var monstersData = []

    lodash.each(gameEvents, function(event){

      if(event.type != "ELITE_MONSTER_KILL"){
        return
      }

      var killer = hitPlayers[event.killerId]
      if(!killer){
        return
      }

      var killerId = killer.participantId
      var killerTeamId = killer.teamId

      var monsterData = {
        event_time: event.timestamp,
        killer_color: killerTeamId == 100 ? 1 : 2,
        killer_id: killerId,
        killer_team_id: killerTeamId,
        monster_sub_type: event.monsterSubType,
        monster_type: event.monsterType,
        point_x: event.position.x,
        point_y: event.position.y
      }

      monstersData.push(monsterData)
    })

    return monstersData
  },
  generate_wards_data: function(stat, timeline){

    //暂时不做插眼排眼数据
    return []
  }
}

export default GameReplayDataLoader


